import styled from 'styled-components';
import { Row, Col } from 'antd';
import { MailOutlined } from '@ant-design/icons';

import useI18n from '../../common/hooks/useI18n';
import { IOffice } from '../../common/model/office.model';
import { IContact } from '../../common/model/mailchimp/contact.model';

import { RequestInfoButton } from '../flatDetail';
import { OfficesMap } from '../offices';

type Props = {
  office: IOffice;
  onButtonClick: (contact: IContact) => void;
};

const BackgroundImage = styled.div<{ imageUrl: string }>`
  background-image: url(${(props) => props.imageUrl});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  margin-left: auto;
  margin-right: auto;
  height: 160px;
  width: 160px;
  border-radius: 50%;
  @media ${(props) => props.theme.breakpoints.xs} {
    height: 100px;
    width: 100px;
  }
`;

const InfoContainer = styled.div`
  margin-top: 24px;
  text-align: center;
`;

const InfoTitle = styled.div`
  font-size: 20px;
  line-height: 27px;
  font-weight: 600;
`;

const InfoDivider = styled.div`
  border: 1px solid ${(props) => props.theme.colors.primary};
  background-color: ${(props) => props.theme.colors.primary};
  width: 32px;
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: auto;
  margin-right: auto;
`;

const InfoDescription = styled.div`
  font-size: 18px;
  line-height: 32px;
  @media ${(props) => props.theme.breakpoints.lgd} {
    font-size: 16px;
  }
  @media ${(props) => props.theme.breakpoints.smd} {
    line-height: 24px;
  }
`;

const InformationSection: React.FC<Props> = ({ office, onButtonClick }) => {
  const i18n = useI18n();

  return (
    <Row gutter={[32, 32]}>
      <Col xs={24} lg={8} style={{ alignSelf: 'center' }}>
        <BackgroundImage imageUrl={office.imageUrls[0]} />
        <InfoContainer>
          <InfoTitle>{office.name}</InfoTitle>
          <InfoDivider />
          <InfoDescription>
            <div>{office.address}</div>
            <div>{`${office.postalCode} ${office.city}`}</div>
            <div>
              <a href={`tel:${office.phone}`}>{office.phone}</a>
            </div>
            <div style={{ marginTop: 8 }}>
              <RequestInfoButton
                onButtonClick={onButtonClick}
                text={
                  <>
                    <MailOutlined />{' '}
                    {i18n.t('flatDetail.actions.requestInfoShort')}
                  </>
                }
              />
            </div>
          </InfoDescription>
        </InfoContainer>
      </Col>
      <Col xs={24} lg={16}>
        {typeof google !== 'undefined' &&
          typeof google.maps.Map !== 'undefined' && (
            <OfficesMap offices={[office]} />
          )}
      </Col>
    </Row>
  );
};

export default InformationSection;
